/**
 * Google Responsive Search Ad limits — the client's copy of
 * `CHANNEL_CONSTRAINTS.rsa` (@fias/db-types), which the server enforces on
 * every write. Mirrored because `@fias/webapp-client` does not depend on
 * `@fias/db-types`; pinned by `tests/architecture/adopt-rsa-limits-client-parity.test.ts`.
 * Imports nothing.
 */
export const RSA_LIMITS = {
  headlines: { min: 3, max: 15, maxChars: 30 },
  descriptions: { min: 2, max: 4, maxChars: 90 },
  paths: { max: 2, maxChars: 15 },
} as const;
